import { DEFAULT_EMAIL_LINK_COLOR } from 'constants/defaultConstants';
import { Society } from 'types';

export const getSocietyEmailLinkColor = (society: Society): string => {
  const customization = society?.customization?.theme;
  return customization?.emailLinkColor || DEFAULT_EMAIL_LINK_COLOR;
};
